import c from "../common"
export default {
    // Main Page
    Related: "相關的推廣活動",
    LastEdit: "上次修改",
    CreateDate: "創建時間",
    Choose: "請從左邊選擇活動",
    NoEvent: "暫無相關活動",
    Joined: "已參與商戶",
    VoucherNDiscount: c.voucher.chn + " & " + c.discount.chn,
    Estamp: c.estamp.chn,
    EarnPeriod: "賺取積分期至",
    EarnRate: "賺取1分",
    Event: c.event.chn,

    // Status
    Pending: c.Pending.chn,
    OnGoing: c.OnGoing.chn,
    Expired: c.Expired.chn,
    Cancelled: c.Cancelled.chn, 
    WaitApprove: c.WaitApprove.chn,

    // Common
    To: "至",
    NA: c.NA.chn,
    NoDescription: c.NA.chn + "簡介",

    // Message

}